import React from 'react';
import Typography from '@mui/material/Typography';
import CreateNewResourceButton from './CreateNewResourceButton';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/material';
const ProjectDetailsView = () => (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", padding: "0.25em 0.5em" },
    React.createElement(Box, null,
        React.createElement(Typography, { sx: {
                padding: '2px',
                userSelect: "none",
            }, textOverflow: "ellipsis" }, "Project")),
    React.createElement(CreateNewResourceButton, null)));
export default ProjectDetailsView;
//# sourceMappingURL=ProjectDetailsView.js.map